import React, { FC } from 'react';
// eslint-disable-next-line import/no-unresolved
import { NewsItemProps } from './types';
import locationSVG from '../../../../icons/location.svg';
import viewsSVG from '../../../../icons/views.svg';
import dateSVG from '../../../../icons/date.svg';
// @ts-ignore
import { FormattedDate, Icon } from '@plone/volto/components';
// @ts-ignore
import { Link } from 'react-router-dom';

const SmallNews: FC<NewsItemProps> = ({
  id,
  title,
  location,
  visited_users,
  description,
  image,
  readed,
  review_state,
  created,
  onMouseEnter,
}) => {
  return (
    <Link
      to={id}
      className={`small-news ${readed ? 'readed' : 'not-readed'}`}
      aria-label={title}
      onMouseEnter={onMouseEnter}
    >
      <div className={'left-column'}>
        {image ? (
          // only decoration, the link already carries the title (#22806)
          <img src={`${id}/@@images/image/mini`} alt="" loading="lazy" />
        ) : (
          <></>
        )}
      </div>
      <div className={'mid-column'}>
        <span
          className={`title ${review_state === 'private' ? 'private' : 'not-private'}`}
        >
          {title}
        </span>
        <span className={`description`}>{description}</span>
        <div className={'metadata-row'}>
          <div className={'views'}>
            <Icon className={'icon'} name={viewsSVG} size={'1.25rem'} />
            <p className={'value'}> {visited_users.length} </p>
          </div>
          <div className={'location'}>
            <Icon className={'icon'} name={locationSVG} size={'1.25rem'} />
            <div className={'value'}>
              {location.map((location, idx) => (
                <p key={idx} className={'entry'}>
                  {location.title}
                </p>
              ))}
            </div>
          </div>
          <div className={`date`}>
            <Icon className={'icon'} name={dateSVG} size={'1.25rem'} />
            <FormattedDate
              date={created}
              format={{ year: 'numeric', month: 'short', day: 'numeric' }}
              long={false}
              includeTime={false}
              relative={false}
              className=""
              locale={false}
              children={false}
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SmallNews;
